import * as Yup from "yup";

const contaValidator = Yup.object().shape({
  nome: Yup.string().required("Nome"),
  tipoConta: Yup.string().required("Tipo Conta"),
  dataSaldoInicial: Yup.date().nullable(),
  saldoInicial: Yup.number().nullable(),
  aberturaAutomatica: Yup.boolean().required("Abertura Automática"),
  chavePix: Yup.string().nullable(),
  nomeGerente: Yup.string().nullable(),
  telefoneGerente: Yup.string().nullable(),
  emailGerente: Yup.string().nullable(),
  ativado: Yup.boolean().nullable(),
  bancoId: Yup.number().when("caixaBanco", (caixaBanco) => {
    return caixaBanco 
      ? Yup.number().nullable().required("Instituição Financeira")
      : Yup.number().nullable().optional()
  }),
  agencia: Yup.number().when("caixaBanco", (caixaBanco) => {
    return caixaBanco 
      ? Yup.number().nullable().required("Agência")
      : Yup.number().nullable().optional()
  }),
  digitoAgencia: Yup.number().when("caixaBanco", (caixaBanco) => {
    return caixaBanco 
      ? Yup.number().nullable().required("Dígito da Agência")
      : Yup.number().nullable().optional()
  }),
  conta: Yup.number().when("caixaBanco", (caixaBanco) => {
    return caixaBanco 
      ? Yup.number().nullable().required("Conta Bancária")
      : Yup.number().nullable().optional()
  }),
  digitoConta: Yup.number().when("caixaBanco", (caixaBanco) => {
    return caixaBanco 
      ? Yup.number().nullable().required("Dígito da Conta Bancária")
      : Yup.number().nullable().optional()
  }),
  contaBancariaTipo: Yup.number().when("caixaBanco", (caixaBanco) => {
    return caixaBanco 
      ? Yup.string().nullable().required("Tipo de Conta Bancária")
      : Yup.string().nullable().optional()
  }),
  codigoBeneficiario: Yup.number().when("caixaBanco", (caixaBanco) => {
    return caixaBanco 
      ? Yup.string().nullable().required("Código Beneficiário")
      : Yup.string().nullable().optional()
  }),
  contato: Yup.string().when("caixaBanco", (caixaBanco) => {
    return caixaBanco 
      ? Yup.string().nullable().required("Conta Bancária")
      : Yup.string().nullable().optional()
  }),
  endereco: Yup.object().when("caixaBanco", (caixaBanco) => {
    return caixaBanco 
      ? Yup.object().shape({
          cep: Yup.number().required("CEP"),
          logradouro: Yup.string().required("Endereço"),
          numero: Yup.number().required("Número de Residência"),
          bairro: Yup.string().required("Bairro"),
          cidadeId: Yup.number().required("Cidade"),
        })
      : Yup.object().nullable().optional()
  }),
  responsaveisList: Yup.array()
    .of(
      Yup.object().shape({
        usuarioId: Yup.number(),
      })
    )
    .min(1, "Lista de Responsáveis")
    .required("Lista de Responsáveis"),
});

export default contaValidator;
